<template>
    <div>
        <div v-show="!webSave">
            <div class="form-group">
                <label class="control-label">Company</label>
                <company :create="true" :errorName="model.errorName" v-model="model.company" :min-length="0"></company>
            </div>
            <div class="form-group" style="display: inline-block; padding: 16px 0 0;">
                <label class="control-label">What type of website?</label>
                <p class="instruct-sm" style="top:10px;">Click to select Your CMS</p>
            </div>
            <ul class="cms-app-list list-inline" style="display: inline;">
                <li v-for="(app, index) in apps" @click="setApp(app)" class="clickable" :class="{ 'active': app === model.app_id }">
                    <i v-bind:class="'icon icon-' + app"></i>
                    <h6>{{ convertName(app) }}</h6>
                </li>
            </ul>

            <div class="form-group" v-show="model.app_id === 'download'">
                <label class="control-label">Clone Existing Site</label>
                <search-websites minLength="2" v-model="model.old_site" ></search-websites>
            </div>

            <txt name="site_name" label="Site Name" v-model="model.site_name"></txt>
            <p class="instruct-sm">Name your wesbite eg. "John's Blog"</p>

            <div class="popup-split left">
                <txt id="domain" label="live_domain" v-model="model.domain"></txt>
                    <p class="instruct-sm">If you wish to deploy directly to the live domain, ensure the Dev Domain is empty.</p>
            </div>

            <div class="popup-split right">
                <div class="form-group">
                     <label for="dev_domain" class="control-label">Dev Domain</label>
                     <div class="input-group">
                          <input type="text" class="form-control" id="dev_domain" v-model="model.dev_domain">
                          <span class="input-group-addon">{{ model.demo_domain }}</span>
                     </div>
                    <br />
                    <p class="instruct-sm">This is the address for your development site. If this field is populated, your website will be deployed to this address.</p>
                </div>
            </div>

            <div class="popup-split left">
                <list id="server_id" label="Web Server" :list='servers' :value="model.server_id" v-model="model.server_id" :usekey="true"></list>
            </div>
            <div class="popup-split right">
                <div class="form-group disabled">
                    <label class="control-label disabled"> Theme</label>
                    <select class="form-control disabled" disabled="disabled" placeholder="">
                        <option value="" selected disabled> - Feature Coming Soon - </option>
                    </select>
                </div>
            </div>

            <div class="payment hide">
                <div v-if="requiresPayment">
                    <div v-if="errorMessage">{{ this.errorMessage }}</div>
                    <label class="control-label">Payment</label>
                    <span class="popup-alert warning">New website deployments cost $10/month or $110/year. You can cancel at anytime by going to Billing.</span>
                    <subscription v-model="dropinPayload" :token="token"></subscription>

                    <label class="control-label">How do you want to pay?</label>
                    <div class="popup-split left">
                        <div class="input-group">
                            <input type="radio" value="yearly" id="plan-yearly" v-model="model.plan" />
                            <label for="plan-yearly">&nbsp;&nbsp;$110 per year (save $10)</label>
                        </div>
                    </div>
                    <div class="popup-split right">
                        <div class="input-group">
                            <input type="radio" value="monthly" id="plan-monthly" v-model="model.plan" />
                            <label for="plan-monthly">&nbsp;&nbsp;$10 per month</label>
                        </div>
                    </div>
                </div>
                <div v-if="!requiresPayment && noPaymentReason !== ''">
                    <label class="control-label">Payment</label>
                    <span class="popup-alert success" v-if="noPaymentReason === 'byo'">{{ trans('payment_byo_server') }}</span>
                    <span class="popup-alert success" v-if="noPaymentReason === 'trial'">{{ trans('payment_trial') }}</span>
                    <span class="popup-alert success" v-if="noPaymentReason === 'other'">{{ trans('payment_lucky') }}</span>
                </div>
            </div>

            <div class="buttons">
                <button @click.prevent="store" type="submit" class="btn btn-success btn-sm" :disabled="!submitReady">
                    <span v-if="submitReady"><i class="icon icon-tick"></i> Deploy Site</span>
                    <span v-if="!submitReady"><i class="icon icon-spinner fa-spin"></i> loading...</span>
                </button>
            </div>
        </div>
        <div v-show="webSave" id="websiteSaving">
            <div id="savedLinks" v-if="websiteUrl !== ''">
                <span>Your website has been successfully deployed. <br>What do you want to do next?</span><br><br>
                <a :href="websiteUrl.view" target="_blank" class="btn btn-primary">Visit Website</a>
                <a :href="websiteUrl.edit" target="_blank" class="btn btn-primary">Website Admin</a>
                <!-- Company -->
                <a :href="websiteUrl.company.link" class="btn btn-primary">{{ websiteUrl.company.name }}</a>
            </div>
            <div v-else>
                <i v-if="deployNotice.length" class="icon icon-cog fa-spin"></i>
                <span v-if="deployNotice.length">{{ deployNotice }}...</span>
                <div v-if="progress.value" class="progress">
                    <div class="progress-bar progress-bar-striped active" role="progressbar" :aria-valuenow="progress.value" aria-valuemin="0" aria-valuemax="100" :style="'width: ' + progress.value + '%'">
                        <span class="sr-only">{{ progress.value }}% Complete</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            name: { default: '' },
        },
        components: {
            'company': require('../../components/autocomplete/company.vue').default,
            'subscription': require('../subscription/payment.vue').default,
            'search-websites': require('../../components/autocomplete/websites.vue').default,
        },
        computed: {
            servers() {
                return {
                    666999: 'AWS'
                };
            }
        },
        data() {
            return {
                progress: {
                    maxAbove: 20,
                    incrementBy: 0.33,
                    fake: false,
                    real: 0,
                    value: 1,
                    timer: false
                },
                deployNotice: false,
                websiteUrl: '',
                token: false,
                webSave: false,
                demo_domain: window.DEMO_DOMAIN,
                noPaymentReason: '',
                errorMessage: false,
                submitReady: false,
                requiresPayment: false,
                dropinPayload: false,
                apps: ['wordpress', 'opencart', 'download'],
                model: {
                    errorName: 'websiteCreate',
                    nonce: false,
                    old_site: {},
                    app_id: 'wordpress',
                    public_id: 0,
                    site_name: '',
                    panelName: this.name,
                    company: '',
                    is_live: 0,
                    server_id: 666999,
                    lock_dev_domain: false,
                    domain: '',
                    dev_domain: '',
                    demo_domain: '.myworkdemo.com.au',
                    username: '',
                    password: '',
                    cms_password: '',
                    admin_url: '',
                    plan: 'yearly',
                    ftp_list: []
                }
            }
        },
        created() {
            this.resetPanel();
            this.checkPayment();
            // this.checkServer();
            this.$eventHub.$on('websiteSubmit', this.store);
            this.$eventHub.$on('setWebsite', this.setWebsite);
            this.$eventHub.$on('saving' + this.name, this.savingWebsite);
            this.$eventHub.$on('websiteCreateUpdate' + this.name, this.websiteComplete);
            this.$eventHub.$on('setProgress' + this.name, this.setProgress);
            this.$eventHub.$on('emitErrors', this.resetPanel);
            this.$eventHub.$on('deployUpdate', this.deployUpdate);
        },
        watch: {
            'dropinPayload': function () {
                this.submitReady = true;
            },
            'model.server_id': function () {
                this.checkPayment();
            },
            'model.site_name': function(val){
                if(this.model.lock_dev_domain) return;
                this.model.dev_domain = cleanUrl(val);
            }
        },
        methods: {
            setProgress(value) {
                this.progress.real = value;
                this.progress.value = value;
                if (! this.progress.fake) {
                    this.progress.fake = true;
                    this.progress.timer = setInterval(this.fakeProgress, 500);
                }
            },
            fakeProgress() {
                if ( ! this.progress.fake ) return;
                let maxFake = this.progress.real + this.progress.maxAbove;
                let newValue = this.progress.value + this.progress.incrementBy;
                if (maxFake > this.progress.value && newValue < 99) {
                    fyi('fake progress value');
                    this.progress.value = newValue;
                } else {
                    fyi('Hit upper increment limit');
                    this.progress.fake = false;
                    window.clearInterval(this.progress.timer);
                }
            },
            convertName(app) {
                if (app === 'wordpress') {
                    return 'WordPress';
                } if (app === 'download') {
                    return 'Clone';
                }
                return app.ucfirst();
            },
            deployUpdate(data) {
                if (data.panelName === this.name) {
                    this.deployNotice = data.title;
                }
            },
            resetPanel(blerg) {
                this.webSave = false;
                this.$eventHub.$emit('updateDialogHeading' + this.name, {
                    heading: 'Create Website',
                    icon: 'icon-create-circle'
                });
            },
            websiteComplete(data){
                this.$eventHub.$emit('updateDialogHeading' + this.name, {
                    heading: 'Website Deployed',
                    icon: 'icon-tick'
                });
                this.websiteUrl = data;
            },
            lockDevDomain(){
                if (this.model.dev_domain == '') {
                    this.model.lock_dev_domain = false;
                    return;
                }
                this.model.lock_dev_domain = true;
            },
            checkPayment() {
                this.requiresPayment = false;
                // If server_id is NaN then it is a hosted server
                if (isNaN(this.model.server_id)) {
                    this.submitReady = false;
                    this.axios.get('/api/subscription/check').then((response) => {
                        let data = response.data;
                        // If still on trial
                        if (data.trial == true) {
//                            this.requiresPayment = false;
                            this.noPaymentReason = 'trial';
                            this.submitReady = true;
                            return;
                        }
                        this.token = data.token;
                        this.requiresPayment = true;
                    }).catch((errors) => {
                        console.log(errors);
                    });
                    return;
                }
                // Else it is byo server
                this.noPaymentReason = 'byo';
                this.dropinPayload = false;
                this.submitReady = true;
            },
            store() {
                if (this.requiresPayment && this.dropinPayload) {
                    this.dropinPayload.requestPaymentMethod((dropinPayloadErr, dropinPayload) => {
                        if (dropinPayloadErr) {
                            this.errorMessage = 'There was an error with Drop-In Payload! Message: ' + dropinPayloadErr.message;
                            return;
                        }
//                        this.dropinPayload = dropinPayload;
                        this.model.nonce = dropinPayload.nonce;
                        this.createWebsite();
                    });
                    return;
                }

                this.setProgress(1);

                // Fake straight up deploy better
                if (this.model.app_id === 'wordpress') {
                    this.progress.maxAbove = 100;
                    this.progress.incrementBy = 7;
                }

                this.createWebsite();
            },
            createWebsite(){
                this.model.preventDialogClose = true;
                this.model.modal = false;
                this.model.panelName = this.name;
//                this.model.closeDialog = true;
                this.$store('/api/website/aws-store', this);
                this.$eventHub.$emit('latest-notif', {
                    title: 'Website Deploying',
                    timeout: true
                });
                this.deployUpdate({
                    panelName: this.name,
                    title: 'Website deploying'
                })
            },
            savingWebsite(){
                this.webSave = true;
                this.$eventHub.$emit('updateDialogHeading', {
                    heading: 'Website Deploying',
                    icon: 'icon-cog fa-spin'
                });
            },
            setApp(app){
                this.model.app_id = app;
                this.model.old_site = {};
                this.$eventHub.$emit('blurWebsite');
                        // this.checkServer();
            },
            checkServer(){
                if (typeof window.DEFAULT_SERVERS['all'] !== 'undefined') {
                    this.model.server_id = window.DEFAULT_SERVERS['all'];
                }
                if (typeof window.DEFAULT_SERVERS[this.model.app_id] !== 'undefined') {
                    this.model.server_id = window.DEFAULT_SERVERS[this.model.app_id];
                }
            },
            setWebsite(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('websiteSubmit', this.store);
            this.$eventHub.$off('setWebsite', this.setWebsite);
            this.$eventHub.$off('saving' + this.name, this.savingWebsite);
            this.$eventHub.$off('websiteCreateUpdate', this.websiteComplete);
            this.$eventHub.$off('emitErrors', this.resetPanel);
            this.$eventHub.$off('deployUpdate', this.deployUpdate);
        }
    }
</script>
<style>
    #savedLinks {
        text-align: center;
        min-height: 100px;
    }
    .clickable{
        cursor: pointer;
    }
</style>